import { defineModuleGlobal } from './moduledata';

export const moduleGlobalLanguage = defineModuleGlobal<string>('PUBLIC', 'language', null);
